<template>
  <transition name="med-fade">
    <h5 v-if="tableIsOverflowing">
      <em> Hold <code>shift</code> and scroll to scroll sideways </em>
    </h5>
  </transition>
</template>

<script>
export default {
  name: "OverflowMessage",
  props: {
    refName: {
      required: true,
      type: String
    }
  },
  data() {
    return {
      tableIsOverflowing: false
    }
  },
  mounted() {
    this.checkOverflowing()
  },
  methods: {
    /**
     * Indicates whether or not the refName's x axis is overflowing
     * @returns {boolean}
     */
    checkOverflowing() {
      let el = this.$parent.$refs[this.refName].$el
      if (!el) return false
      let curOverflow = el.style.overflow

      if (!curOverflow || curOverflow === "visible")
        el.style.overflow = "hidden"

      let isOverflowing =
        el.clientWidth < el.scrollWidth || el.clientHeight < el.scrollHeight

      el.style.overflow = curOverflow
      this.tableIsOverflowing = isOverflowing
      this.$forceUpdate()
    }
  }
}
</script>

<style scoped>
.med-fade-enter-active,
.med-fade-leave-active {
  transition: all 1s ease;
}
.med-fade-enter, .med-fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
